import React from 'react';
import './Experience.css';

function Experience() {
  const experiences = [
    {
      company: 'OpenText',
      location: 'Bangalore',
      position: 'Software Engineer',
      duration: 'Feb 2024 — Present',
      type: 'current',
      achievements: [
        'Migrated all services to Kubernetes using Helm charts and Docker, improving scalability and deployment efficiency',
        'Developed Apache Storm topologies with custom bolts for real-time message processing',
        'Led team to migrate from Spring Framework to Spring Boot, reducing load times by 15% and improving responsiveness by 17%',
        'Designed and built AI-powered chatbot using all-MiniLM embeddings with FAISS vector database for semantic search',
        'Migrated CI/CD from TeamCity to GitLab, reducing manual effort by 40%',
        'Implemented mTLS security for Kafka across all services',
        'Built and optimized Apache Camel Core routes for system integration'
      ]
    },
    {
      company: 'Netcracker',
      location: 'Bangalore',
      position: 'Software Engineer',
      duration: 'Aug 2021 — Feb 2024',
      type: 'previous',
      achievements: [
        'Developed interactive websites with Angular frontend and Spring Framework backend',
        'Implemented design patterns reducing code defects by 20%',
        'Worked on CSRD product with multiple microservices deployed on Kubernetes',
        'Prepared deliverables for multiple releases with refactoring of existing functionality',
        'Contributed to performance optimization and system architecture improvements'
      ]
    }
  ];

  return (
    <section id="experience" className="experience">
      <div className="container">
        <h2 className="section-title reveal">Work Experience</h2>
        <p className="section-subtitle reveal">
          Building impactful software at scale
        </p>
        
        <div className="timeline">
          {experiences.map((exp, index) => (
            <div key={index} className={`timeline-item reveal`}>
              <div className="timeline-marker">
                <div className={`timeline-dot ${exp.type === 'current' ? 'active' : ''}`} />
              </div>
              
              <div className="timeline-card">
                <div className="timeline-card-header">
                  <div className="company-info">
                    <div className="company-title-row">
                      <h3 className="company-name">{exp.company}</h3>
                      {exp.type === 'current' && (
                        <span className="current-badge">Current</span>
                      )}
                    </div>
                    <p className="position">{exp.position}</p>
                    <p className="location">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                      </svg>
                      {exp.location}
                    </p>
                  </div>
                  <span className="duration-badge">{exp.duration}</span>
                </div>
                
                <ul className="achievements">
                  {exp.achievements.map((achievement, idx) => (
                    <li key={idx}>
                      <span className="achievement-arrow">▹</span>
                      {achievement}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Experience;
